
export default {
    routes: [
        {
            path: '',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/index'
            },
            component: () => import('@/components/zhgd/index')
        },
        {
            path: 'index',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/index'
            },
            component: () => import('@/components/zhgd/index')
        },
        {
            path: 'shiming',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/shiming'
            },
            component: () => import('@/components/zhgd/shiming')
        },
        {
            path: 'shiming/renyuandingwei',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: 'shiming/renyuandingwei'
            },
            component: () => import('@/components/zhgd/renyuandingwei')
        },
        {
            path: 'shiming/feifaruqin',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: 'shiming/feifaruqin'
            },
            component: () => import('@/components/zhgd/feifaruqin')
        },
        {
            path: 'shiming/gaoweiquyu',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: 'shiming/gaoweiquyu'
            },
            component: () => import('@/components/zhgd/gaoweiquyu')
        },
        {
            path: 'shiming/shishijiankong',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: 'shiming/shishijiankong'
            },
            component: () => import('@/components/zhgd/shishijiankong')
        },
        {
            path: 'shipin',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/shipin'
            },
            component: () => import('@/components/zhgd/shipin')
        },
        {
            path: 'shipin1',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/shipin1'
            },
            component: () => import('@/components/zhgd/shipin1')
        },
        {
            path: 'shipin2',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/shipin2'
            },
            component: () => import('@/components/zhgd/shipin2')
        },
        {
            path: 'huanjing',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/huanjing'
            },
            component: () => import('@/components/zhgd/huanjing')
        },
        {
            path: 'huanjing/xichexitong',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: 'huanjing/xichexitong'
            },
            component: () => import('@/components/zhgd/xichexitong')
        },
        {
            path: 'huanjing/wupaopenlin',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: 'huanjing/wupaopenlin'
            },
            component: () => import('@/components/zhgd/wupaopenlin')
        },
        {
            path: 'anquan',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/anquan'
            },
            component: () => import('@/components/zhgd/anquan')
        },
        {
            path: 'anquan/tasiliebiao',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/tasiliebiao'
            },
            component: () => import('@/components/zhgd/tasiliebiao')
        },
        {
            path: 'anquan/shengjiangji',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/shengjiangji'
            },
            component: () => import('@/components/zhgd/shengjiangji')
        },
        {
            path: 'anquan/liaotai',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/liaotai'
            },
            component: () => import('@/components/zhgd/liaotai')
        },
        {
            path: 'anquan/yanghushi',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/yanghushi'
            },
            component: () => import('@/components/zhgd/yanghushi')
        },
        {
            path: 'anquan/gaozhimo',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/gaozhimo'
            },
            component: () => import('@/components/zhgd/gaozhimo')
        },
        {
            path: 'anquan/yangan',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/yangan'
            },
            component: () => import('@/components/zhgd/yangan')
        },
        {
            path: 'anquan/zhinengdianbiao',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/zhinengdianbiao'
            },
            component: () => import('@/components/zhgd/zhinengdianbiao')
        },
        {
            path: 'anquan/zhinengshuibiao',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/zhinengshuibiao'
            },
            component: () => import('@/components/zhgd/zhinengshuibiao')
        },
        {
            path: 'fuzhu',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/fuzhu'
            },
            component: () => import('@/components/zhgd/fuzhu')
        },
        {
            path: 'fuzhu/luosisongjin',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/luosisongjin'
            },
            component: () => import('@/components/zhgd/luosisongjin')
        },
        {
            path: 'fuzhu/huoyunchengzhong',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/huoyunchengzhong'
            },
            component: () => import('@/components/zhgd/huoyunchengzhong')
        },
        {
            path: 'fuzhu/anquanguangbo',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/anquanguangbo'
            },
            component: () => import('@/components/zhgd/anquanguangbo')
        },
        {
            path: 'fuzhu/hunningtuwendu',
            meta: {
                requireAuth: true,
                needPower: false,
                activeSideMenu: '/hunningtuwendu'
            },
            component: () => import('@/components/zhgd/hunningtuwendu')
        },
        // {
        //     path: 'dmap',
        //     name: 'dmap',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dmap'
        //     },
        //     component: () => import('@/components/dust/maps')
        // },
        // {
        //     path: '/monitor/project',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/monitor/project'
        //     },
        //     component: () => import('@/components/zhgd/xmqj'),
        //     children: xmqjRouter.routes
        // },
        // {
        //     path: '/statistics/overview',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/statistics/overview'
        //     },
        //     component: () => import('@/components/miss_d')
        // },
        // {
        //     path: '/statistics/dust',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/statistics/dust'
        //     },
        //     component: () => import('@/components/dust/home')
        // },
        // {
        //     path: '/statistics/tower',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/statistics/tower'
        //     },
        //     component: () => import('@/components/tower/home')
        // },
        // {
        //     path: '/statistics/lifter',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/statistics/lifter'
        //     },
        //     component: () => import('@/components/lifter/home')
        // },
        // {
        //     path: '/dev/video',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/video'
        //     },
        //     component: () => import('@/components/video/equipments')
        // },
        // {
        //     path: '/dev/face',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/face'
        //     },
        //     component: () => import('@/components/face/equipments')
        // },
        // {
        //     path: '/dev/personel',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/personel'
        //     },
        //     component: () => import('@/components/face/personel')
        // },
        // {
        //     path: '/dev/dust',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/dust'
        //     },
        //     component: () => import('@/components/dust/equipments')
        // },
        // {
        //     path: '/dev/tower',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/tower'
        //     },
        //     component: () => import('@/components/tower/equipments')
        // },
        // {
        //     path: '/dev/lifter',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/lifter'
        //     },
        //     component: () => import('@/components/lifter/equipments')
        // },
        // {
        //     path: '/dev/db',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/db'
        //     },
        //     component: () => import('@/components/dianbiao/equipments')
        // },
        // {
        //     path: '/dev/sb',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/sb'
        //     },
        //     component: () => import('@/components/miss_d')
        // },
        // {
        //     path: '/dev/sgdt',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/sgdt'
        //     },
        //     component: () => import('@/components/miss_d')
        // },
        // {
        //     path: '/dev/yhs',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/yhs'
        //     },
        //     component: () => import('@/components/miss_d')
        // },
        // {
        //     path: '/dev/xlpt',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/xlpt'
        //     },
        //     component: () => import('@/components/xlpt/equipments')
        // },
        // {
        //     path: '/dev/gzm',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/gzm'
        //     },
        //     component: () => import('@/components/gzm/equipments')
        // },
        // {
        //     path: '/dev/cckz',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/cckz'
        //     },
        //     component: () => import('@/components/cckz/equipments')
        // },
        // {
        //     path: '/dev/ygsb',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/ygsb'
        //     },
        //     component: () => import('@/components/miss_d')
        // },
        // {
        //     path: '/dev/dlsb',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/dev/dlsb'
        //     },
        //     component: () => import('@/components/miss_d')
        // },
        // {
        //     path: '/history/dust',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/history/dust'
        //     },
        //     component: () => import('@/components/dust/logs')
        // },
        // {
        //     path: '/history/tower',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/history/tower'
        //     },
        //     component: () => import('@/components/tower/logsnew')
        // },
        // {
        //     path: '/history/lifter',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/history/lifter'
        //     },
        //     component: () => import('@/components/lifter/logs')
        // },
        // {
        //     path: '/history/db',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/history/db'
        //     },
        //     component: () => import('@/components/dianbiao/logs')
        // },
        // {
        //     path: '/history/xlpt',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/history/xlpt'
        //     },
        //     component: () => import('@/components/xlpt/logs')
        // },
        // {
        //     path: '/history/gzm',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/history/gzm'
        //     },
        //     component: () => import('@/components/gzm/logs')
        // },
        // {
        //     path: '/warn/overview',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/warn/overview'
        //     },
        //     component: () => import('@/components/miss_d')
        // },
        // {
        //     path: '/warn/offline',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/warn/offline'
        //     },
        //     component: () => import('@/components/zhgd/onlineLogs')
        // },
        // {
        //     path: '/warn/dust',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/warn/dust'
        //     },
        //     component: () => import('@/components/dust/alarms')
        // },
        // {
        //     path: '/warn/tower',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/warn/tower'
        //     },
        //     component: () => import('@/components/tower/alarms')
        // },
        // {
        //     path: '/warn/lifter',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/warn/lifter'
        //     },
        //     component: () => import('@/components/miss_d')
        // },
        // {
        //     path: '/warn/gzm',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/warn/gzm'
        //     },
        //     component: () => import('@/components/gzm/alarms')
        // },
        // {
        //     path: 'equipments',
        //     name: 'equipments',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/equipments'
        //     },
        //     component: () => import('@/components/dust/equipments')
        // },
        // {
        //     path: 'detail',
        //     name: 'detail',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/detail'
        //     },
        //     component: () => import('@/components/dust/detail')
        // },
        // {
        //     path: 'logs',
        //     name: 'logs',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/logs'
        //     },
        //     component: () => import('@/components/dust/logs')
        // },
        // {
        //     path: 'alarms',
        //     name: 'alarms',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/alarms'
        //     },
        //     component: () => import('@/components/dust/alarms')
        // },
        // {
        //     path: '/records/stat',
        //     name: 'onlineLogs',
        //     meta: {
        //         requireAuth: true,
        //         needPower: true,
        //         activeSideMenu: '/records/stat'
        //     },
        //     component: () => import('@/components/dust/onlineLogs')
        // },
        // {
        //     path: '/records/operate',
        //     meta: {
        //         requireAuth: true,
        //         needPower: true,
        //         activeSideMenu: '/records/operate'
        //     },
        //     component: () => import('@/components/miss_d')
        // },
        // {
        //     path: 'curves',
        //     name: 'curves',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/curves'
        //     },
        //     component: () => import('@/components/dust/curves')
        // },
        // {
        //     path: '/monitor/plist',
        //     meta: {
        //         requireAuth: true,
        //         needPower: false,
        //         activeSideMenu: '/monitor/plist'
        //     },
        //     component: () => import('@/components/zhgd/plist')
        // },
        // {
        //     path: '/users',
        //     name: 'users',
        //     meta: {
        //         requireAuth: true,
        //         needPower: true,
        //         activeSideMenu: '/users'
        //     },
        //     component: () => import('@/components/zhgd/users')
        // },
        // {
        //     path: 'configs',
        //     name: 'configs',
        //     meta: {
        //         requireAuth: true,
        //         needPower: true,
        //         activeSideMenu: '/configs'
        //     },
        //     component: () => import('@/components/zhgd/configs')
        // },
        // {
        //     path: '/warn/conf',
        //     meta: {
        //         requireAuth: true,
        //         needPower: true,
        //         activeSideMenu: '/warn/conf'
        //     },
        //     component: () => import('@/components/miss_d')
        // },
        // {
        //     path: 'my',
        //     name: 'my',
        //     meta: {
        //         requireAuth: true,
        //         needPower: true,
        //         activeSideMenu: '/my'
        //     },
        //     component: () => import('@/components/zhgd/my')
        // },
        // {
        //     path: 'password',
        //     name: 'password',
        //     meta: {
        //         requireAuth: true,
        //         needPower: true,
        //         activeSideMenu: '/password'
        //     },
        //     component: () => import('@/components/zhgd/password')
        // },
    ]
}



// WEBPACK FOOTER //
// ./src/router/zhgd.js